import gql from 'graphql-tag'
import { get } from 'ts-object-path'
import { useQuery } from '@apollo/react-hooks'
import {
  BalanceChartByAccountId_accountsCharts,
  BalanceChartByAccountId_accountsChartsVariables,
} from '../../../_generated/BalanceChartByAccountId_accountsCharts'
import { Precision } from '../../../_generated/globalTypes'

// TODO use `Fragments` for same charts props

export const QUERY = gql`
query BalanceChartByAccountId_accountsCharts($id: ID!, $precision: Precision!) {
  charts {
    byAccountId(id: $id) {
      id: accountId
      balance(precision: $precision) {
        values
        labels
        begin
        valuesCount
        currency
      }
    }
  }
}`

export type Q = BalanceChartByAccountId_accountsCharts
export type V = BalanceChartByAccountId_accountsChartsVariables
export type R = Q['charts']['byAccountId']['balance']

export const parseData = (data: Q): R => {
  return get(data, p=> p.charts.byAccountId.balance)
}

export function Use(clientId: string) {
  const query = useQuery<Q, V>(
      QUERY,
      {
          variables: {
              id: clientId,
              precision: Precision.MONTH
          }
      }
  )

  const { loading, error, data } = query

  return { loading, error, data: parseData(data) }
}
